exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-colorpicker{\n  display:flex;\n  flex-flow:nowrap;\n}\n.input-group-colorpicker .colorpicker-input{\n  width:100%;\n}", ""]);

// exports
